import { OptionProps } from 'jobseeker-ui'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: 'https://restcountries.com/v3.1',
  withoutSource: true,
})

export const countryCodeOptions = async () => {
  const { data } = await axios.get(`/all?fields=name,idd`)

  return data.map((country: any) => {
    const name = country.name.common
    const phoneCode = `${country.idd.root}${country.idd.suffixes[0]}`
    const truncatedName = name.length > 15 ? name.slice(0, 15) + '...' : name

    return {
      label: `(${phoneCode}) ${truncatedName}`,
      value: phoneCode.replace('+', ''),
    }
  }) as OptionProps[]
}

export const countries = async () => {
  try {
    const { data } = await axios.get('all')
    return data.map((country: any) => ({
      name: country.name.common,
      official: country.name.official,
      capital: country.capital?.[0] || '',
      region: country.region,
      languages: country.languages || {},
      population: country.population,
      flag: country.flags.png,
    }))
  } catch (error) {
    console.error('Error fetching countries:', error)
    return []
  }
}
